import { AdaptiveCardWrapper, FlexBox } from "@brg/ui";
import { FC } from "react";
import { ProjectsGridNew } from "shared/components/grids";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { computeCard } from "shared/helpers/types/computed/ComputeCard";
import { getCardNumber } from "shared/helpers/utils/getCardNumber";
import { isServer } from 'shared/constants/isServer';

const CardComponent = isServer ? {} : require('adaptive-cards');


export const DesignerDiscountTab: FC<{ data?: any[], isLoading?: boolean, isCert?: boolean }> = ({ data, isLoading, isCert }) => {

    return (
        <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
            <ProjectsGridNew k={20} isLoading={isLoading} columns={4} mobileColumns={2}>
                {data?.map((card, index) => {
                    return (
                        <ProjectCardNew
                            project={computeCard(card) as any}
                            linkTo={process.env.REACT_APP_URL_GALLERY + '/card/' + card?.cardId}
                            isEditable={false}
                            withoutGoToProject
                            withoutRepost
                            isCanNotBeDraft
                            //@ts-ignore
                            key={(card?.cardId || '') + index}
                            {...computeCard(card)}
                            card={card}
                            isCert={isCert}
                        />
                    )
                })}
            </ProjectsGridNew>
        </FlexBox>
    )
}

export const DesignerCertCardImage: FC<{ card?: any }> = ({ card }) => {

    return (
        <AdaptiveCardWrapper
            cardProps={{
                data: {
                    ...card,
                    number: getCardNumber(card?.sequenceItem?.number),
                },
                templateType: "WarholCardA4",
            }}
            images={card.images}
            >
            <CardComponent.MasterCard/>
        </AdaptiveCardWrapper>
    )
}import { AdaptiveCardWrapper, FlexBox } from "@brg/ui";
import { FC } from "react";
import { ProjectsGridNew } from "shared/components/grids";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { computeCard } from "shared/helpers/types/computed/ComputeCard";
import { getCardNumber } from "shared/helpers/utils/getCardNumber";
import { isServer } from 'shared/constants/isServer';

const CardComponent = isServer ? {} : require('adaptive-cards');


export const DesignerDiscountTab: FC<{ data?: any[], isLoading?: boolean, isCert?: boolean }> = ({ data, isLoading, isCert }) => {

    return (
        <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
            <ProjectsGridNew k={20} isLoading={isLoading} columns={4} mobileColumns={2}>
                {data?.map((card, index) => {
                    return (
                        <ProjectCardNew
                            project={computeCard(card) as any}
                            linkTo={process.env.REACT_APP_URL_GALLERY + '/card/' + card?.cardId}
                            isEditable={false}
                            withoutGoToProject
                            withoutRepost
                            isCanNotBeDraft
                            //@ts-ignore
                            key={(card?.cardId || '') + index}
                            {...computeCard(card)}
                            card={card}
                            isCert={isCert}
                        />
                    )
                })}
            </ProjectsGridNew>
        </FlexBox>
    )
}

export const DesignerCertCardImage: FC<{ card?: any }> = ({ card }) => {

    return (
        <AdaptiveCardWrapper
            cardProps={{
                data: {
                    ...card,
                    number: getCardNumber(card?.sequenceItem?.number),
                },
                templateType: "WarholCardA4",
            }}
            images={card.images}
            >
            <CardComponent.MasterCard/>
        </AdaptiveCardWrapper>
    )
}